import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import { useDisclosure, Button, Text } from '@chakra-ui/react'


function BasicUsage() {
  const { isOpen, onOpen, onClose } = useDisclosure()

    return (
      <>
            <Button bgColor="transparent" border= '2px' borderColor= 'white' onClick={onOpen} color='white'>SCOPRI DI PIÙ</Button>

            <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader>TEXT</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                  <Text style={{fontSize:"30px", fontFamily:"Montserrat"}}>Le Lands (i terreni digitali) ospiteranno un mercato interno di rivendita dei prodotti digitali e reali attraverso la costruzione di negozi e bancarelle. Saranno messi a disposizione degli avatar dedicati al carnevale, tratti da maschere come quelle di Pulcinella, Arlecchino, Frappiglia, Pantalone, Colombina e Lu Guazzarò.
                  Il primo contatto verrà effettuato con il lancio della prima serie da 70 nft.
                  Ai possessori dei primi NFT verrà data la possibilità di affittare uno spazio e creare una collaborazione e nel particolare avrà il diritto di:
                  ;        Un Avatar unico gratuito di The Sandbox creato appositamente da noi
                  ;        Accesso agli eventi programmati nelle Lands
                  ;        Accesso al canale Discord privato
                  ;        Creare un eventuale collaborazione per la creazione dei prodotti
                  ;        Invito agli eventi programmati in Real Life
                  ;        Accesso anticipato con sconto annesso allo Shop dei prodotti
                  ;        Sconti alle prossime collections di NFT
                  ;        Diventare un nostro rivenditore
                  ;        Voto nella futura DAO
                  ;        Accedere a tutti i possibili sviluppi futuri nel progetto.
                  </Text>
                  </ModalBody>

                  <ModalFooter>
                      <Button colorScheme='blue' mr={3} onClick={onClose}>
                        Close
                      </Button>
                  </ModalFooter>
                </ModalContent>
            </Modal>
      </>
    )
}
export default BasicUsage;
  